export const MockCities = ['Toronto', 'Montreal', 'Ottawa'];

export const NumberOfGuests = [1, 2, 3, 4];

export const RoomsAvailable = ['1', '2', '3', '4', '5', '6','7', '8', '9', '10'];